












import { defineComponent } from '@vue/composition-api';
import { usePanel } from './pannel.hook';
import ASecondaryBtn from '../../base/app/buttons/ASecondaryBtn.vue';
import { MIGRATION } from '@ligo/dashboard/customer/store';

const SHOW_ALL_ICON = 'img:/icons/create-folder.svg';

export default defineComponent({
  name: 'Panel',
  components: {
    ASecondaryBtn
  },
  setup() {
    const { contractsPreview, loading, headers } = usePanel();

    const openContract = () => {
      window.open(MIGRATION.CONTRACT, '_blank');
    };

    return {
      contractsPreview,
      loading,
      headers,
      MIGRATION,
      SHOW_ALL_ICON,
      openContract
    };
  }
});
